/**
 * Static PDF served from `public/docs/` (Vite serves `public/` at site root).
 */
export const SLA_CONNECTION_GUIDE_PDF = "/docs/SLA_JSON_Schema_final_Guide.pdf";
